import React, { useEffect, useState } from 'react';

export default function TicketList({ eventId, onClose }) {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTickets = async () => {
      try {
        const res = await fetch(`/api/ticketsForEvent/${eventId}`);
        const data = await res.json();
        if (res.ok && data.success) {
          setTickets(data.tickets);
        } else {
          alert('Failed to load tickets');
        }
      } catch (err) {
        console.error(err);
        alert('Error fetching tickets');
      } finally {
        setLoading(false);
      }
    };

    fetchTickets();
  }, [eventId]);

  if (loading) return <p>Loading tickets...</p>;

  return (
    <div className="mt-4 p-6 border rounded-lg bg-white shadow-md">
      <h3 className="text-xl font-bold mb-4">🎟️ Sold Tickets</h3>

      {tickets.length === 0 ? (
        <p className="text-gray-600">No tickets sold yet.</p>
      ) : (
        <div className="space-y-4">
          {tickets.map(ticket => (
            <div
              key={ticket._id}
              className="flex flex-col md:flex-row md:items-center md:justify-between border border-gray-200 rounded-lg p-4 shadow-sm hover:shadow transition"
            >
              <div className="flex-1">
                <p className="text-sm text-gray-500">Buyer</p>
                <p className="font-semibold text-gray-800">{ticket.buyerEmail}</p>
              </div>

              <div className="flex-1 mt-2 md:mt-0 md:ml-6">
                <p className="text-sm text-gray-500">QR Code</p>
                <p className="font-mono text-gray-700 break-all">{ticket.qrCode}</p>
              </div>

              <div className="mt-2 md:mt-0 md:ml-6">
                <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
                  ticket.redeemed ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {ticket.redeemed ? '✅ Redeemed' : '⏳ Not Redeemed'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={onClose}
        className="mt-6 px-6 py-3 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
      >
        Close
      </button>
    </div>
  );
}
